<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- // Logo -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo">
            <span class="logo-sm">
              <img src="@/assets/images/logo/logo_mobile.png" alt="" height="24" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo/logo_green.png" alt="" height="28" />
            </span>
          </router-link>
        </div>

        <!-- // Toggle Button -->
        <button type="button" id="vertical-menu-btn"
                class="btn btn-sm pt-2 px-3 font-size-16 vertinav-toggle header-item waves-effect"
                @click="toggleMenu()">
          <i class="fa fa-fw fa-bars" />
        </button>
      </div>

      <div class="d-flex" v-if="$_utils.isEmpty(username)">
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon waves-effect login-btn" @click="login">
            <i class="mdi mdi-login font-size-16 align-middle me-2" />
            <span>Login</span>
          </button>
        </div>
      </div>

      <div class="d-flex" v-if="!$_utils.isEmpty(username)">
        <!-- // Full Screen Button -->
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon waves-effect" @click="initFullScreen">
            <i class="mdi mdi-fullscreen" />
          </button>
        </div>

        <b-dropdown class="d-inline-block" variant="white"
                    menu-class="dropdown-menu-end" toggle-class="header-item">
          <template #button-content>
            <img class="rounded-circle header-profile-user"
                 src="@/assets/images/users/ion_ci_01.png"
                 alt="Header Avatar" />
            <span class="d-none d-xl-inline-block ms-2 me-1">{{ username }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </template>

          <b-dropdown-item>
            <i class="mdi mdi-account-circle text-muted font-size-16 align-middle me-2" />
            <span class="align-middle" key="t-profile">{{ $t("user.profile") }}</span>
          </b-dropdown-item>

          <div class="dropdown-divider"></div>

          <a href="javascript:;" v-on:click="logout" class="dropdown-item">
            <i class="mdi mdi-logout text-muted font-size-16 align-middle me-2" />
            <span class="align-middle" key="t-logout">{{ $t("common.logout") }}</span>
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    layoutscroll: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    layoutscroll: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case false:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
            case true:
              document.body.setAttribute("data-layout-scrollable", "true");
              break;
            default:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
          }
        }
      },
    },
  },
  data() {
    return {
      username: this.$_app.user.email
    };
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");

      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },



    login() {
      const vm = this;
      vm.$router.push( {path: '/login'} );
    },
    logout() {
      const vm = this;
      vm.$_app.logout();
      vm.$router.push( {path: '/login'} );
      //vm.$router.go();
    },


  },
};
</script>
